import { DefaultButton, mergeStyles, Spinner, SpinnerSize, Stack } from '@fluentui/react';
import React from 'react';

import Navbar from '../Components/Navbar';
import Routes from '../Routes';
import { theme } from '../utils/theme';
import { useAppSelector } from './store';
import { Link } from 'react-router-dom';

const UserLoadingSpinner = () => (
  <Stack verticalAlign="center" className={spinnerStackStyles}>
    <Spinner label="Kullanıcı yükleniyor" size={SpinnerSize.large} />
    <br />
    <DefaultButton onClick={() => window.location.href = "/login"} style={{width: "20%", marginLeft: "40%"}}>Yüklenmediyse giriş yap</DefaultButton>
  </Stack>
);
const Content = () => (
  <div className={contentStyles}>
    <Routes />
  </div>
);

export const App: React.FunctionComponent = () => {
  const isUserdataLoaded = useAppSelector(
    (state) => state.auth.user && state.auth.userdata && true
  );

  return (
    <Stack className={stackStyles}>
      <Navbar />
      {isUserdataLoaded ? <Content /> : <UserLoadingSpinner />}
    </Stack>
  );
};

const stackStyles = mergeStyles({
  height: "100vh",
  backgroundColor: theme.palette.neutralLighterAlt,
});
const spinnerStackStyles = mergeStyles({
  height: "80vh",
});
const contentStyles = mergeStyles({
  display: "block",
  padding: "2px 0 1.5rem 0",
});
